import logo from "../../assets/smart-budget-logo.png"

export default function Logo() {
    return(
        <div className="logo">
            <img id="logo" src={logo} alt="Smart Spending Logo" />
        </div>
    )
}